import ArrowUpIcon from "@src/app/assets/icons/arrow-up.svg?react";
import cx from "classnames";
import type { ReactElement } from "react";
import { useEffect, useState } from "react";

function goTop() {
  window.scrollTo({ top: 0, behavior: "smooth" });
}

export default function ScrollToTop(): ReactElement {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 100) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    });
  }, []);

  return (
    <button
      id="scroll-to-top"
      className={cx(
        "fixed right-[30px] bottom-[30px] bg-gray-900 bg-opacity-60 p-[6px] rounded-full text-white",
        {
          "opacity-1 animate-fade-in-up": isVisible,
          "opacity-0 animate-fade-out-up": !isVisible,
        },
      )}
      onClick={goTop}
      data-testid="scroll-to-top"
      aria-label="Return to Top"
      tabIndex={0}
    >
      <ArrowUpIcon fill="white" width={20} height={20} />
    </button>
  );
}
